import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';

import { mqTablet } from '../../../styled/helpers/helpers';
import { ProfilePicture } from '../../../styled/components/components';
import { COLOR_4 } from '../../../styled/variables/variables';
import './messages.css'

import messageService from '../../../services/message/message.service';

import domEventsUtil from '../../../utils/dom-events/dom-events.util';
import eventConstants from '../../../constants/events';

const customId = "custom-id-yes";

const Messages = ({
  user,
  messages,
}) => {
  const [messagesData, setMessagesData] = useState([]);

  useEffect(() => {
    setMessagesData(messages);
  }, [messages]);

  const handleDeleteMessage = async messageId => {
    try {
      domEventsUtil.dispatch({
        name: eventConstants.LOADING_ANIMATION,
        params: { show: true, },
      });

      await messageService.deleteMessage({ messageId, token: user.token });

      const newMessages = messagesData.filter(item => item._id !== messageId);

      setMessagesData(newMessages);

      toast.success('A mensagem foi apagada com sucesso!', {
        autoClose: false,
        toastId: customId,
      });
    } catch {
      toast.error('Houve um erro ao apagar essa mensagem, tente novamente!', {
        autoClose: false,
        toastId: customId,
      });
    } finally {
      domEventsUtil.dispatch({
        name: eventConstants.LOADING_ANIMATION,
        params: { show: false, },
      });
    }
  }

  return (
    <Wrapper>
      {messagesData.length === 0 &&
        <Message>Não há mensagens para este anúncio</Message>
      }
      {messagesData.map(item =>
      (
        <div key={item._id} style={{ position: 'relative' }}>
          <div className={'container_button'}>
            <button onClick={() => handleDeleteMessage(item._id)}>Apagar</button>
          </div>
          <div style={{ marginLeft: 85 }}>
            <ProfilePicture style={{ width: 65, height: 60, backgroundColor: 'gray', float: 'left', marginLeft: -85 }} />
            <h3>{item.name} em {(new Date(item.date)).toLocaleDateString('pt-BR')}</h3>
            <p><strong>E-mail:</strong> {item.email}</p>
            <p><strong>Telefone:</strong> {item.phone}</p>
          </div>
          <p style={{ textAlign: 'justify', marginBottom: 50, marginTop: 20 }}>{item.message}</p>
        </div>
      )
      )}
    </Wrapper>
  );
}

export default Messages;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 500px;
	align-self: center;

	${mqTablet`
	width: 100%;
	max-width: 1000px;
	align-self: center;
	` }
`;

const Message = styled.p`
      font-size: 20px;
      font-weight: 600;
      color: ${COLOR_4};
      align-self: center;
`;
